























import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

@Component
export default class Confirm extends ViewBase {
  @Prop({ type: Boolean, default: true }) visible!: boolean
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: String, default: '' }) tip1!: string
  @Prop({ type: String, default: '' }) tip2!: string
  @Prop({ type: String, default: '' }) btnyes!: string
  @Prop({ type: String, default: '' }) btnno!: string
  @Prop({ type: String, default: '' }) btn3!: string
  svisible = false
  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
    //  console.log(visible)
    // if (visible) {
    // }
  }
  onOk() {
    this.$emit('onOk')
  }
  onOk2() {
    this.$emit('onOk2')
  }
  onCancel() {
    this.svisible = false
    this.$emit('onCancel')
  }
}
